import { createTheme } from '@material-ui/core'

import { light, dark } from './palette'
import typography from './typography'
import overrides from './overrides'

const shadows = [
  'none',
  '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', // shadow-sm
  '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)', // shadow-md
  '0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.03)', // shadow-lg
  '0 20px 25px -5px rgba(0,0,0,0.05), 0 10px 10px -5px rgba(0,0,0,0.03)', // shadow-xl
  '0 4px 20px 0 rgba(0, 0, 0, 0.05)', // Nosso shadow custom do HeaderCard
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
]

export const getTheme = (isDarkMode) => {
  const currentPalette = isDarkMode ? dark : light
  const activeOverrides = overrides(currentPalette, isDarkMode, shadows) // Converte tokens em estilos injetados! 🛡️✨

  return createTheme({
    palette: currentPalette,
    typography,
    overrides: activeOverrides,
    shadows,
  })
}

const theme = getTheme(false)

export default theme
